import { FaqSchemaItem, toFaqList } from '../../builders/faq'

export const modernizationFaqItems: FaqSchemaItem[] = [
  {
    question: '自社のシステムが古く、ドキュメントがまったくありません。対応可能ですか？',
    answer:
      '生成AIによりコードから仕様を逆算し、自動ドキュメント化が可能です。専門のエンジニアが補足し、精度を高めます。',
  },
  {
    question: '改修リリース後のトラブルが心配です。',
    answer:
      'E2Eテストで動作確認を行い、必要に応じて本番リリース前に検証環境を設けるなど、万全の体制で進めます。',
  },
  {
    question: 'すでにクラウド化はしているが、AI活用や最新アーキテクチャの導入を検討しています。',
    answer:
      'クラウド環境であっても、アプリケーション構造の見直しや改修をサポートします。マイクロサービス化などもご相談ください。',
  },
  {
    question: '大掛かりな移行ではなく、まず小規模な改修だけお願いしたいです。',
    answer:
      '部分的な改修・ドキュメント整備だけでも支援可能です。段階的にモダナイゼーションを進めるアプローチを推奨しています。',
  },
  {
    question: '保守や運用のエンジニアがいない状態ですが大丈夫でしょうか？',
    answer: '専門チームによるサポート体制を整えておりますので、運用引き継ぎにも対応いたします。',
  },
]

export const modernizationFaqList = toFaqList(
  'よくあるご質問',
  'モダナイゼーションに関するよくあるご質問にお答えします',
  modernizationFaqItems,
)
